import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { encode as base64Encode } from "base-64";
import { Config } from "../Constants/Config";
import { logout } from "../Utils/CommonFuntions";

export const apiClient = axios.create({
  baseURL: Config.BASE_URL,
  timeout: Config.TIMEOUT,
  headers: {
    "Content-Type": "application/json",
  },
});

// Per-call configs (e.g. Bearer-token auth flows) may set their own
// Authorization header explicitly; only fall back to Basic auth + the
// current session id when the caller hasn't already provided one.
apiClient.interceptors.request.use((config) => {
  if (!config.headers.Authorization) {
    const sessionId = (global as any).token;
    config.headers.Authorization =
      "Basic " +
      base64Encode(
        `${Config.BASIC_AUTH_USERNAME}:${Config.BASIC_AUTH_PASSWORD}`
      );
    config.headers.sessionid = sessionId ?? null;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      logout("network");
    }
    return Promise.reject(error);
  }
);

export const get = <T = any>(
  url: string,
  config?: AxiosRequestConfig
): Promise<AxiosResponse<T>> => apiClient.get<T>(url, config);

export const post = <T = any>(
  url: string,
  data?: unknown,
  config?: AxiosRequestConfig
): Promise<AxiosResponse<T>> => apiClient.post<T>(url, data, config);

export const put = <T = any>(
  url: string,
  data?: unknown,
  config?: AxiosRequestConfig
): Promise<AxiosResponse<T>> => apiClient.put<T>(url, data, config);

export const del = <T = any>(
  url: string,
  config?: AxiosRequestConfig
): Promise<AxiosResponse<T>> => apiClient.delete<T>(url, config);

export const bearerAuthConfig = (token: string | null | undefined): AxiosRequestConfig => ({
  headers: {
    Authorization: token ? `Bearer ${token}` : "Bearer",
  },
});
